import React from "react";
// import axios from "axios";
import "./App.css";
import Footer from "./Components/Layout/Footer";
import Header from "./Components/Layout/Header";
import MainContent from "./Components/MainContent";
import Fab from "./Components/Fab";
import AddModal from "./Components/Modal/AddModal";

class App extends React.Component {
  state = {
    data: [
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-13T17:56:57.861Z"),
        hidden: false,
        status: "completed",
        _id: "5da3656e680cec346ab52525",
        title: "Operational Management",
        body: "Presentasi SCM",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-13T17:56:57.861Z"),
        hidden: false,
        status: "completed",
        _id: "5da3656e680cec3460a52525",
        title: "e-CRM and e-Marketing",
        body: "Mobile payment analysis",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-15T17:53:00.000Z"),
        hidden: false,
        status: "completed",
        _id: "5da364b8680cec3460a52522",
        title: "Database",
        body: "Assignment topik join table",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-17T17:52:00.000Z"),
        hidden: false,
        status: "todo",
        _id: "5da3645f680cec3460a52521",
        title: "Statistic 2",
        body: "Halaman 212",
        __v: 0
      },
      {
        date: new Date("2019-10-12T05:44:41.961Z"),
        deadline: new Date("2019-10-17T18:19:07.566Z"),
        hidden: false,
        status: "doing",
        _id: "5da169ed1988721bf4a8c7c9",
        title: "Cross Cultural",
        body: "XD",
        __v: 0
      },
      {
        date: new Date("2019-10-12T05:44:41.961Z"),
        deadline: new Date("2019-10-18T16:35:21.702Z"),
        hidden: false,
        status: "doing",
        _id: "5da16c9c1988721bf4a8c7cd",
        title: "Microeconomy",
        body: "Halaman 301",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-18T17:50:00.000Z"),
        hidden: false,
        status: "completed",
        _id: "5da363f4680cec3460a5251f",
        title: "Research Methodology",
        body: "Buat bab 1",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-25T18:38:00.000Z"),
        hidden: false,
        status: "doing",
        _id: "5da3638c680cec3460a5251e",
        title: "Entrepreneurship 1",
        body: "Buat ide bisnis teknologi",
        __v: 0
      },
      {
        date: new Date("2019-10-12T06:08:30.265Z"),
        deadline: new Date("2019-10-26T19:07:00.000Z"),
        hidden: false,
        status: "todo",
        _id: "5da16eb84bb7282cbcb94321",
        title: "Mathematics",
        body: "Forum sesi 2",
        __v: 0
      },
      {
        date: new Date("2019-10-13T17:47:15.430Z"),
        deadline: new Date("2019-10-28T17:55:00.000Z"),
        hidden: false,
        status: "todo",
        _id: "5da36517680cec3460a52524",
        title: "E-Business",
        body: "Analisa e-marketplace",
        __v: 0
      }
    ],
    currentTab: 0,
    openAddModal: false
  };

  // componentDidMount() {
  //   axios
  //     .get("http://localhost:5000/get")
  //     .then(response => {
  //       // console.log(response.data);
  //       const { data } = response.data;
  //       this.setState({
  //         data: data
  //       });
  //     })
  //     .catch(err => console.log(err));
  // }

  onChangeTab = value => {
    this.setState({
      currentTab: value
    });
  };

  setOpenAddModal = value => {
    this.setState({
      openAddModal: value
    });
  };

  newDataHandler = object => {
    this.setState({
      data: [object, ...this.state.data]
    });
  };

  updateDataHandler = object => {
    const newData = this.state.data.map(value => {
      if (value._id === object.id) {
        value.title = object.title;
        value.body = object.body;
        value.deadline = object.deadline;
      }
      return value;
    });
    // console.log(newData);
    this.setState({
      data: newData
    });
  };

  deleteDataHandler = object => {
    // console.log(object);
    const { data } = this.state;
    const newData = data.filter(data => data._id !== object._id);
    this.setState(state => ({
      data: newData
    }));
  };

  changeStatusStateHandler = object => {
    const { body } = object;
    const { data } = this.state;
    console.log(body);

    const newData = data.map(value => {
      if (value._id === body.id) {
        value.status = body.status;
      }
      return value;
    });
    // console.log(newData);
    this.setState({
      data: newData
    });
  };

  dropStateHandler = object => {
    const { body } = object;
    const { data } = this.state;
    // console.log(body);

    const newData = data.map(value => {
      if (value._id === body._id) {
        value.status = body.status;
      }
      return value;
    });
    // console.log(newData);
    this.setState({
      data: newData
    });
  };

  render() {
    // console.log(this.state.data);

    return (
      <div className="App">
        <Header />
        <AddModal
          open={this.state.openAddModal}
          setOpen={this.setOpenAddModal}
          newDataHandler={this.newDataHandler}
        />
        <MainContent
          data={this.state.data}
          currentTab={this.state.currentTab}
          deleteDataHandler={this.deleteDataHandler}
          changeStatusStateHandler={this.changeStatusStateHandler}
          updateDataHandler={this.updateDataHandler}
          dropStateHandler={this.dropStateHandler}
        />
        <Fab setOpen={this.setOpenAddModal} />
        <Footer
          currentTab={this.state.currentTab}
          onChangeTab={this.onChangeTab}
        />
      </div>
    );
  }
}

export default App;
